import Reveal from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";
import StoreInfo from "@/components/StoreInfo";
import { Phone, Mail, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data/products";

const Contact = () => (
  <main className="pt-32 pb-24 px-6 md:px-10 grain spotlight relative min-h-screen">
    <div className="max-w-7xl mx-auto">
      <Reveal className="text-center max-w-3xl mx-auto">
        <p className="uppercase text-xs sm:text-sm font-semibold tracking-[0.2em] text-spice">Contact Us</p>
        <h1 className="font-serif font-bold tracking-tight text-ink text-4xl sm:text-5xl lg:text-6xl mt-4">
          बात करिए, <span className="italic text-spice">हम सुन रहे हैं।</span>
        </h1>
        <p className="text-bark mt-6 leading-relaxed">
          Monthly ration lists, bulk festive orders, home delivery or a quick price check — reach us any way you like.
        </p>
      </Reveal>

      <Reveal delay={0.1} className="flex flex-wrap justify-center gap-4 mt-10">
        <a
          data-testid="contact-call-btn"
          href={CONTACT.phoneHref}
          className="inline-flex items-center gap-2 bg-ink text-cream font-semibold text-sm px-7 py-4 rounded-full hover:bg-spice transition-colors duration-300"
        >
          <Phone size={16} /> {CONTACT.phone}
        </a>
        <a
          data-testid="contact-whatsapp-btn"
          href={CONTACT.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#25D366] text-white font-semibold text-sm px-7 py-4 rounded-full hover:bg-[#128C7E] transition-colors duration-300"
        >
          <MessageCircle size={16} /> WhatsApp Us
        </a>
        <a
          data-testid="contact-email-btn"
          href={CONTACT.emailHref}
          className="inline-flex items-center gap-2 border border-ink/25 text-ink font-semibold text-sm px-7 py-4 rounded-full hover:border-spice hover:text-spice transition-colors duration-300"
        >
          <Mail size={16} /> {CONTACT.email}
        </a>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-20 items-start">
        <Reveal>
          <StoreInfo />
        </Reveal>
        <Reveal delay={0.15} className="bg-white border border-linen rounded-3xl p-8 md:p-10 shadow-sm">
          <h2 className="font-serif font-semibold text-coffee text-2xl mb-2">Send an Enquiry</h2>
          <p className="text-mut text-sm mb-6">We usually reply within a few working hours.</p>
          <ContactForm />
        </Reveal>
      </div>
    </div>
  </main>
);

export default Contact;
